export const createTrainingSlice = set => ({
  training: null,
  setTraining: value => set(() => ({ training: value })),

  trainings: [],
  setTrainings: values => set(() => ({ trainings: values })),

  trainingsRef: [],
  setTrainingsRef: values => set(() => ({ trainingsRef: values })),

  trainingsFilter: { search: '', tags: [] },
  setTrainingsFilter: value =>
    set(state => ({ trainingsFilter: { ...state.trainingsFilter, ...value } })),

  selectedTrainingExercises: [],
  trainingDraggable: false,
  setTrainingDraggable: value => set(() => ({ trainingDraggable: value }))
});
